import { List, ListItem } from '@mui/material';
import { memo, RefObject } from 'react';
import { IEntities } from '@legacy/apis/types/responseBase';
import { IEmployeeSearchResProperties } from '@legacy/apis/resourcePlannerAPI';
import { AssignDialog } from '../../../components/AssignFlow/components/AssignDialog';
import {
  EmployeeWithCompetence,
  EmployeeWithCompetenceSkeleton,
} from '../../../components/AssignFlow/components/EmployeeWithCompetence';
import styles from '../SearchForResourceDialog.module.scss';

interface ResourceListProps {
  employeeList: (IEntities<IEmployeeSearchResProperties> | undefined)[];
  searchContainerResults: RefObject<HTMLUListElement | null>;
  startsAt: Date;
  endsAt: Date;
  from: string;
  projectId: string;
  selectItemIndex: number;
  showDepartmentFilter: boolean;
  showLegalEntityFilter: boolean;
  workItemSourceReferenceId: string;
  hasNextPage?: boolean;
  isFetchingNextPage: boolean;
  query: string;
  observerRef: (node: HTMLLIElement | null) => void;
}

export const ResourceList = memo(
  ({
    employeeList,
    searchContainerResults,
    startsAt,
    endsAt,
    from: name,
    projectId,
    selectItemIndex,
    showDepartmentFilter,
    showLegalEntityFilter,
    workItemSourceReferenceId,
    hasNextPage,
    isFetchingNextPage,
    query,
    observerRef,
  }: ResourceListProps) => (
    <List className={styles.list} ref={searchContainerResults}>
      {employeeList.map((resource, i) => {
        if (resource) {
          const { properties } = resource;

          return (
            <ListItem
              data-automation-id={`ResourceItem-${properties?.userId}`}
              disablePadding
              key={properties?.userId}
              sx={{ position: 'relative' }}
            >
              <AssignDialog
                dates={[startsAt, endsAt]}
                from={name}
                projectId={projectId}
                selected={selectItemIndex === i}
                showDepartmentFilter={showDepartmentFilter}
                showLegalEntityFilter={showLegalEntityFilter}
                taskId={workItemSourceReferenceId}
                to={properties.fullName}
                userId={properties.userId}
              >
                <EmployeeWithCompetence
                  query={query}
                  resource={properties}
                  showDepartmentFilter={showDepartmentFilter}
                  showLegalEntityFilter={showLegalEntityFilter}
                />
              </AssignDialog>
            </ListItem>
          );
        }

        return null;
      })}

      {hasNextPage && (
        <ListItem disablePadding ref={observerRef}>
          {isFetchingNextPage && <EmployeeWithCompetenceSkeleton />}
        </ListItem>
      )}
    </List>
  ),
);
